import { useAuth } from "../../contexts/auth-context";
import useChatRealtime from "./useChatRealtime";
import useChatRealtimeAuth from "./useChatRealtimeAuth";
import useChatsUnreadSummaryQuery from "./useChatsUnreadSummaryQuery";

// Mounted high in the tree (above route changes) so that:
//   - the unread-summary query is always observed and never garbage-collected
//     while the user is logged in;
//   - the single chat realtime channel stays subscribed even when the user
//     navigates to the chat screen, the orders list, etc. — otherwise we'd
//     miss events between unmounts and the badge would go stale.
const ChatUnreadSubscription = () => {
  const { user } = useAuth();
  const customerId = user && Number(user.id);

  const isRealtimeReady = useChatRealtimeAuth(!!customerId);

  useChatsUnreadSummaryQuery(customerId);
  useChatRealtime(customerId, isRealtimeReady);

  return null;
};

export default ChatUnreadSubscription;
